module.exports = __webpack_public_path__ + "b18805b19444e9045da137f8d937c7ee.svg";